import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-application-status-header',
  templateUrl: './application-status-header.component.html',
  styleUrls: ['./application-status-header.component.scss']
})
export class ApplicationStatusHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
